<!-- Summary -->
<mat-card class="results-content card-margin">
  <mat-card-content>
    <div class="flex-container">
      <div class="flex-item">
        <div class="flex-container kv">
          <div class="flex-item kv-label text-faded">{{ 'common.labels.businessName2' | transloco }}</div>
          <div class="flex-item bold">{{ getString('name') ?? order?.ultimateBeneficialOwnershipRequest?.entityName }}</div>
        </div>

        @if (getString('legalName'); as legalName) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.legalName' | transloco }}</div>
            <div class="flex-item">{{ legalName }}</div>
          </div>
        }

        @if (getString('translatedName'); as translatedName) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.translatedName' | transloco }}</div>
            <div class="flex-item">{{ translatedName }}</div>
          </div>
        }
      </div>

      <div class="flex-item">
        <div class="flex-container kv">
          <div class="flex-item kv-label text-faded">{{ 'common.labels.number2' | transloco }}</div>
          <div class="flex-item bold">{{ getString('number') ?? order?.ultimateBeneficialOwnershipRequest?.entityNumber  }}</div>
        </div>

        @if (getString('craNumber'); as cra) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.craNumber' | transloco }}</div>
            <div class="flex-item">{{ cra }}</div>
          </div>
        }
      </div>
    </div>

    <div class="flex-container">
      <div class="flex-item">
        @if (getEnumString('normalizedEntityType'); as net) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'common.labels.standardizedType' | transloco }}</div>
            <div class="flex-item" style="display:flex;align-items:center;">
              <span style="margin-right:5px">
                <mat-icon style="color:#2B73A8;">{{ getTypeIcon() }}</mat-icon>
              </span>
              {{ net | enumLabel:'normalizedEntityType' }}
            </div>
          </div>
        }

        @if (getString('type'); as registryType) {
        <div class="flex-container kv">
          <div class="flex-item kv-label text-faded">{{ 'common.labels.registryType' | transloco }}</div>
          <div class="flex-item">{{ registryType }}</div>
        </div>
        }
      </div>

      <div class="flex-item">
        @if (getEnumString('normalizedStatus'); as ns) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.standardizedStatus' | transloco }}</div>
            <div class="flex-item" style="display:flex;align-items:center;">
              <span style="margin-right:5px">
                <mat-icon [ngStyle]="getStatusIconColor()">{{ getStatusIcon() }}</mat-icon>
              </span>
              {{ ns | enumLabel:'normalizedStatus' }}
            </div>
          </div>
        }

        @if (getString('status'); as status) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.registryStatus' | transloco }}</div>
            <div class="flex-item">{{ status }}</div>
          </div>
        }
      </div>
    </div>

    @if (getString('homeJurisdiction') || getString('registeredJurisdiction')) {
      <div class="flex-container">
        <div class="flex-item">
          @if (getString('homeJurisdiction'); as home) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ 'uboOverview.homeJurisdiction' | transloco }}</div>
              <div class="flex-item">{{ home }}</div>
            </div>
          }
          @if (getString('registeredJurisdiction'); as reg) {
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded">{{ 'uboOverview.registeredJurisdiction' | transloco }}</div>
              <div class="flex-item">{{ reg }}</div>
            </div>
          }
        </div>
        <div class="flex-item">
          <ng-container>
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded"></div>
              <div class="flex-item"></div>
            </div>
          </ng-container>
          <ng-container>
            <div class="flex-container kv">
              <div class="flex-item kv-label text-faded"></div>
              <div class="flex-item"></div>
            </div>
          </ng-container>
        </div>
      </div>
    }

    <div class="flex-container">
      <div class="flex-item">
        @if (getString('annualReturnDueDate'); as due) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.annualReturnDue' | transloco }}</div>
            <div class="flex-item">{{ due | date: 'yyyy-MM-dd' }}</div>
          </div>
        }

        @if (getString('lastAnnualReturnFiledDate'); as filed) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.lastArFiled' | transloco }}</div>
            <div class="flex-item">{{ filed | date: 'yyyy-MM-dd' }}</div>
          </div>
        }
      </div>

      <div class="flex-item">
        @if (getString('yearOfLastAnnualReturn'); as year) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.yearOfLastAr' | transloco }}</div>
            <div class="flex-item">{{ year }}</div>
          </div>
        }

        @if (getString('annualReturnStatus'); as arStatus) {
          <div class="flex-container kv">
            <div class="flex-item kv-label text-faded">{{ 'uboOverview.annualReturnStatus' | transloco }}</div>
            <div class="flex-item">{{ arStatus | enumLabel:'annualReturnStatus' }}</div>
          </div>
        }
      </div>
    </div>
  </mat-card-content>
</mat-card>